import {  intlFormatPropTypes } from "react-intl";
import { z } from "zod";

const profileNameSchema = (intl: intlFormatPropTypes) =>
  z.object({
    firstName: z
      .string()
      .trim()
      .min(
        2,
        intl.formatMessage({
          id: "hosting.profile_page.first_name_required",
          defaultMessage: "Please enter your first name",
        }),
      ),
    lastName: z
      .string()
      .trim()
      .min(
        2,
        intl.formatMessage({
          id: "hosting.profile_page.last_name_required",
          defaultMessage: "Please enter your last name",
        }),
      ),
  });
type ProfileNameFormValues = z.infer<ReturnType<typeof profileNameSchema>>;

export {profileNameSchema}
export type {ProfileNameFormValues}